import { TeaserData } from 'components/teaser/teaser';
import TeaserGrid from 'components/teaser/teaserGrid';
import { TransLink } from 'components/trans/transLink';
import { graphql } from 'gatsby';
import React from 'react';
import './postsWithTag.scss';

interface Props {
  title: string;
  tag: {
    slug: string;
  };
  postFeed: {
    id: number;
    items: any[];
  };
}

const PostsWithTag: React.FC<Props> = (props) => {
  if (!props.postFeed.items.length) {
    return null;
  }

  return (
    <div className="posts-with-tag">
      <div className="section-header">
        <h5 className="section-header__title">{props.title}</h5>
        {/* <TransLink to="/publikationen/" className="section-header__show-all">
          <span>Alle anzeigen</span>
        </TransLink> */}
      </div>
      <TeaserGrid data={props.postFeed.items} />
    </div>
  );
};

export default PostsWithTag;

export const query = graphql`
  fragment PostWithTagBlock on WpAcfPostswithtagBlock {
    AcfPostsByTags {
      title
      tag {
        slug
      }
    }
  }
`;
